// Déduit le type d'un média à partir de son nom de fichier.
const IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'tif', 'tiff'];
const VIDEO_EXT = ['mp4', 'webm', 'mov', 'avi', 'mkv'];
const AUDIO_EXT = ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac'];
const DOC_EXT = ['pdf', 'doc', 'docx'];

export function getExtension(name = '') {
  const parts = String(name).split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

export function getMediaType(name = '') {
  const ext = getExtension(name);
  if (IMAGE_EXT.includes(ext)) return 'image';
  if (VIDEO_EXT.includes(ext)) return 'video';
  if (AUDIO_EXT.includes(ext)) return 'audio';
  if (DOC_EXT.includes(ext)) return 'doc';
  return 'other';
}
